import {
    AlarmClock,
    Calendar,
    ChartColumn,
    Check,
    CircleAlert,
    CircleHelp,
    DollarSign,
    FileText,
    Flag,
    Hourglass,
    Info,
    Lightbulb,
    Lock,
    Pin,
    Scale,
    Search,
    Shield,
    Star,
    Target,
    TriangleAlert,
    X,
    type LucideIcon,
} from "lucide-react";

import type { EditorialSemantic } from "./utils/editorial-policy";

/**
 * Semantic to icon. Nothing else.
 *
 * Labels, tone and block roles live on the manifest, and duplicating any of
 * them here would put the copy under test a step away from the copy that
 * renders — the first label amendment would ship a wrong accessible name with
 * the suite still green.
 *
 * Static named imports, never a dynamic lookup: the bundler can only drop the
 * ~1500 icons this app does not use if each one it does use is named.
 */
export const GLYPH_REGISTRY = {
    warning: TriangleAlert,
    positive: Check,
    negative: X,
    insight: Lightbulb,
    document: FileText,
    search: Search,
    chart: ChartColumn,
    question: CircleHelp,
    critical: CircleAlert,
    flag: Flag,
    info: Info,
    note: Pin,
    date: Calendar,
    pending: Hourglass,
    deadline: AlarmClock,
    cost: DollarSign,
    shield: Shield,
    legal: Scale,
    target: Target,
    star: Star,
    security: Lock,
} satisfies Record<EditorialSemantic, LucideIcon>;
